import { TApiResponse } from '@/common/types/response';

import { TKeyCountryIndicatorStoreState } from './types';

export function setIndicators(
  state: TKeyCountryIndicatorStoreState,
  res: TApiResponse<TKeyCountryIndicatorStoreState['indicators']>,
) {
  state.indicators = res.data;
}

export function setCountriesList(
  state: TKeyCountryIndicatorStoreState,
  res: TApiResponse<TKeyCountryIndicatorStoreState['countriesList']>,
) {
  state.countriesList = res.data;
}
